
import { Form, Radio } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const LinearPropsDefaults = {
    label: '',
    name: '',
    minNumber: 1,
    maxNumber: 5,
    minLabel: 'Not Likely',
    maxLabel: 'Very Likely',
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false
};

export const FormLinear = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f, _n, _o, _dd, _p, _q, _r, _s;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var linearStyle = _a.linearStyle;
    var leftLabelStyle = {
        color: (_n = linearStyle === null || linearStyle === void 0 ? void 0 : linearStyle.leftColor) !== null && _n !== void 0 ? _n : undefined,
        fontSize: (_o = linearStyle === null || linearStyle === void 0 ? void 0 : linearStyle?.leftSize) !== null && _o !== void 0 ? (isMobile ? _o/1.1 : _o) : undefined,
        fontWeight: (_p = linearStyle === null || linearStyle === void 0 ? void 0 : linearStyle.leftWeight) !== null && _p !== void 0 ? _p : undefined,
    }
    var rightLabelStyle = {
        color: (_q = linearStyle === null || linearStyle === void 0 ? void 0 : linearStyle.rightColor) !== null && _q !== void 0 ? _q : undefined,
        fontSize: (_r = linearStyle === null || linearStyle === void 0 ? void 0 : linearStyle?.rightSize) !== null && _r !== void 0 ? (isMobile ? _r/1.1 : _r) : undefined,
        fontWeight: (_s = linearStyle === null || linearStyle === void 0 ? void 0 : linearStyle.rightWeight) !== null && _s !== void 0 ? _s : undefined,
    }

    var _g, _h, _i, _j, _k, _l, _m, _t;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : LinearPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : LinearPropsDefaults.name;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : LinearPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : LinearPropsDefaults.visible;
    var disabled = (_t = props === null || props === void 0 ? void 0 : props.disabled) !== null && _t !== void 0 ? _t : LinearPropsDefaults.disabled;

    var minNumber = (_i = props === null || props === void 0 ? void 0 : props.minNumber) !== null && _i !== void 0 ? _i : LinearPropsDefaults.minNumber;
    var maxNumber = (_j = props === null || props === void 0 ? void 0 : props.maxNumber) !== null && _j !== void 0 ? _j : LinearPropsDefaults.maxNumber;
    var minLabel = (_dd = props === null || props === void 0 ? void 0 : props.minLabel) !== null && _dd !== void 0 ? _dd : LinearPropsDefaults.minLabel;
    var maxLabel = (_m = props === null || props === void 0 ? void 0 : props.maxLabel) !== null && _m !== void 0 ? _m : LinearPropsDefaults.maxLabel;

    const checkboxNumber = maxNumber - minNumber + 1;
    const options = Array.from({length: checkboxNumber}, (_, index)=> minNumber === 0 ? index : (index+1));

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    
    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;
            
    const [fieldHidden, setFieldHidden] = useState(false);
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
    }, [_a?.fieldSource])

    useEffect(()=>{
        //hiddenOnly字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    return !calVisible && !fieldHidden ? null : <div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <Form.Item
            name={name}
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, requiredText}] : []}
        >
            <div style={{
                display: 'grid',
                width: '100%',
                gridTemplateColumns: 'auto auto auto',
                gap: isMobile ? '8px' : '16px',
                alignItems: 'center',
                margin: '0 auto',
            }}>
                <span style={{
                    ...leftLabelStyle,
                    textAlign: 'right',
                }}>{minLabel}</span>

                <Radio.Group
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${checkboxNumber}, 1fr)`,
                        justifyItems: 'center',
                    }}
                    onChange={(val)=>{
                        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                            ...prevData,
                            [name]: {
                                value: val,
                                isRequired: prevData[name]?.isRequired,
                                type: prevData[name]?.type
                            }
                        }))
                    }}
                    disabled={disabled}
                >
                    {
                        options?.map((item, ind)=>{
                            return <Radio key={ind} value={item} />
                        })
                    }
                </Radio.Group>
                
                <span style={rightLabelStyle}>{maxLabel}</span>
            </div> 
        </Form.Item>
    </div>;
}

